import "../../assets/css/herosection.css";
import Lottie from "lottie-react";
import { useState, useEffect, useRef } from "react";
import lottieAnim from "../../assets/lottie/top_klip.json";

export default function HeroSection() {
  const [email, setEmail] = useState<string>("");
  const playerRef = useRef<any | null>(null);
  const playerContainerRef = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    const playVideoWhenInView = (entries: IntersectionObserverEntry[]) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          playerRef.current?.play();
        } else {
          playerRef.current?.pause();
        }
      });
    };

    const options = {
      root: null,
      rootMargin: "0px",
      threshold: 0.5,
    };

    const observer = new IntersectionObserver(playVideoWhenInView, options);

    if (playerContainerRef.current) {
      observer.observe(playerContainerRef.current);
    }

    return () => {
      observer.disconnect();
    };
  }, []);

  const redirectToSignup = () => {
    window.location.href = `/signup?email=${encodeURIComponent(email)}`;
  };

  return (
    <section className="bg-doctio-beige d-icon-background-hero md:min-h-[532px] py-16">
      <div className="flex flex-col items-center justify-center container md:flex-row py-10 md:py-0 mx-auto">
        <div className="mr-0 md:mx-auto px-2 md:pr-8 flex-1 h-min w-100">
          <h1 className="max-w-2xl md:max-w-none text-d2xl md:text-d4xl font-bold text-doctio-green">
            Din hjælp til journalføring i en travl hverdag
          </h1>

          <div className="space-divider w-2 h-[24px]"></div>

          <p className="max-w-2xl md:max-w-none  font-medium ">
            Gør som tusindvis af andre - optimer din journalføring med Doctio.
            Aldrig har det været nemmere og hurtigere at journalføre. Brug
            mindre tid bag computeren og få mere tid til patienterne.
          </p>

          <div className="md:flex mt-20 items-center">
            <div className="flex rounded-full mx-auto md:m-0 border border-stone-200 p-2 md:w-[34rem] bg-white">
              <input
                type="email"
                name="email"
                id="email"
                className="rounded-full ml-2 text-black focus-visible:outline-none focus:ring-transparent placeholder:text-[15px] block text-[15px] w-full px-6"
                placeholder="Emailadresse"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required={true}
              />
              <button
                type="button"
                onClick={() => redirectToSignup()}
                className="text-white transition-colors duration-300 ease-in-out w-48 hover:bg-white hover:text-doctio-green hover:shadow-md rounded-full font-bold bg-doctio-green focus:ring-4 focus:outline-none px-2 py-2.5 text-center m-0"
              >
                Opret
              </button>
            </div>

            <div className="ml-0 md:ml-8 mt-8 md:mt-0 flex items-center justify-left md: justify-center">
              <p className=" text-dsm font-medium">Gratis. Ingen binding</p>
            </div>
          </div>
        </div>
        <div className="mx-auto flex-1 container px-2 lg:flex">
          <div className="max-w-full overflow-hidden">
            <Lottie
              animationData={lottieAnim}
              autoplay={true}
              lottieRef={playerRef}
              loop={true}
              className="playerHero"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
